import { render, staticRenderFns } from "./TextAreaProps.vue?vue&type=template&id=1974edd0"
import script from "./TextAreaProps.vue?vue&type=script&lang=js"
export * from "./TextAreaProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports